export * from './lib/client-ui-user-recent-projects-view.module';
export * from './lib/user-recent-projects/user-recent-projects.component';
